import { render, staticRenderFns } from "./AddGrades.vue?vue&type=template&id=4133e62a&scoped=true"
import script from "./AddGrades.vue?vue&type=script&lang=js"
export * from "./AddGrades.vue?vue&type=script&lang=js"
import style0 from "./AddGrades.vue?vue&type=style&index=0&id=4133e62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133e62a",
  null
  
)

export default component.exports